!function () {
    if (window.golfbox === undefined) {
        window.golfbox = window.gb = {};
    }

    let _ = {};
    window.gb.logging = _;

    let store = {};
    let watcher = null;

    _.log = function (data, ns) {
        if (!window.debug) return;
        let stack = (store[ns] || (store[ns] = []));
        stack[stack.length] = { timestamp: (new Date()).toISOString(), namespace: ns, data: typeof data === 'object' ? JSON.stringify(data) : data };
    };

    _.output = function (ns) {
        let stack = [];
        if (ns && store[ns]) {
            stack = store[ns];
        } else {
            for (let key in store) {
                stack = stack.concat(store[key]);
            }
        }

        console.table(stack.sort(function(a, b) { return a.timestamp < b.timestamp; }));
    };

    _.clear = function () {
        store = {};
    };

    _.watch = function (ns, timeout) {
        if (console.clear) {
            watcher = setInterval(function () {
                console.clear();
                setTimeout(_.output, 10, ns); // Tímeout is needed for IE/Edge
            }, timeout || 1000);
        } else {
            if (console.error) {
                console.error('console.clear is unsupported');
            } else {
                console.log('console.clear is unsupported');
            }
        }
    };

    _.unwatch = function () {
        clearInterval(watcher);
    };
}()